import React from 'react';
import { Link } from 'react-router-dom';
import { RESEARCH_SUPPORT_BASE } from '../../constants/researchSupport';

const sections = [
  {
    title: 'Document requirements',
    items: [
      'Thesis or project PDF (required) — maximum 15MB',
      'Supporting documents (optional) — transcripts, ethics approval, appendices — maximum 10MB each',
      'Datasets (optional) — CSV, ZIP, or documented supplementary files — maximum 25MB',
    ],
  },
  {
    title: 'Abstract & metadata',
    items: [
      'Abstract should be 150–400 words summarizing objectives, methods, and findings',
      'Provide 3–8 keywords separated by commas',
      'Research title must accurately reflect your work',
    ],
  },
  {
    title: 'Quality standards',
    items: [
      'Original work with proper citations and references',
      'Clear methodology and coherent structure',
      'Figures and tables labeled where applicable',
      'No plagiarized content — submissions may be screened',
    ],
  },
  {
    title: 'Review timeline',
    items: [
      'Initial acknowledgment within 3–5 business days of submission',
      'Review typically takes 2–4 weeks depending on volume',
      'Revision requests include specific, actionable feedback',
    ],
  },
];

function Guidelines() {
  return (
    <div className="space-y-8">
      <p className="text-gray-600 leading-relaxed">
        Follow these guidelines before submitting through the{' '}
        <Link to={`${RESEARCH_SUPPORT_BASE}/apply`} className="text-iof font-medium hover:underline">
          Application Portal
        </Link>
        . Incomplete or non-compliant submissions may be returned for revision.
      </p>

      <div className="space-y-6">
        {sections.map((section) => (
          <section
            key={section.title}
            className="bg-white border border-gray-200 rounded-lg p-6"
          >
            <h2 className="text-lg font-semibold text-gray-900 mb-3">{section.title}</h2>
            <ul className="space-y-2 text-gray-600 text-sm">
              {section.items.map((item) => (
                <li key={item} className="flex gap-2">
                  <span className="text-iof shrink-0">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}

export default Guidelines;
